module.exports = __webpack_public_path__ + "img/birthday.f3006739.svg";